import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.scss']
})
export class InfoModalComponent implements OnInit {

  @Input() title = '';
  @Input() text = '';
  @Input() btnSuccess = '';
  @Input() btnFail = '';
  @Input() timeout = -1;
  @Input() icon: 'warning' | 'success' | null = 'warning';

  public safeHtmlText: SafeHtml;
  private _htmlText = '';

  @Input()
  set htmlText(value: string) {
    this._htmlText = value || '';
    this.safeHtmlText = this._htmlText
      ? this.sanitizer.bypassSecurityTrustHtml(this._htmlText)
      : null;
  }

  get htmlText(): string {
    return this._htmlText;
  }

  constructor(
    private activeModal: NgbActiveModal,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit() {
  }

  close(param) {
    this.activeModal.close(param);
  }

}
